import moment from 'moment';
import _ from 'lodash';

/**
 * Map of fields to be non-falsey for effective date screen to be skipped per line of business.
 */
const requiredFieldsByLOBMap = {
    commercialProperty: ['accountOrgType'],
    businessOwners: ['accountOrgType', 'smallBusinessType']
};

const hasLobData = (submission, lob) => !!submission.lobData[lob];
const isFieldFilled = (submission, fieldPath) => !!_.get(submission, fieldPath);
const getFieldPath = (lob, remainingPath) => `lobData.${lob}.${remainingPath}`;

const isEveryRequiredFieldPresent = (submission) => {
    return Object.entries(requiredFieldsByLOBMap)
        .every(([lob, requiredFields]) => {
            // fields in submission SHOULD be checked for this particular LOB only if the related LOB data is present
            if (!hasLobData(submission, lob)) {
                return true;
            }

            return requiredFields.every(requiredField => {
                return isFieldFilled(submission, getFieldPath(lob, requiredField));
            });
        });
};


// assume the user has visited the first step if some of the optional fields are already filled
const hasUserVisitedFirstStep = (submission) => {
    return isEveryRequiredFieldPresent(submission);
};


export default function (subFlows, branchOnProductCodeFn, TranslateService, LoadSaveService, ViewModelService, ViewModelCtx) {

    function isEffectiveDateInTheFuture(periodStartDate) {
        if (!periodStartDate) {
            return false;
        }
        const currentTime = moment().startOf('day');
        return moment(periodStartDate).isAfter(currentTime, 'day') || moment(periodStartDate).isSame(currentTime, 'day');
    }

    const ACTIONS = {
        saveDraftSubmission: ({
            value: submission
        }) =>
            LoadSaveService.saveSubmission(submission).then(submissionDTO => ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', ViewModelCtx))

    };

    const ACTION_MSGS = {
        saveSubmission: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to save submission',
                message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Saving quote...'
            }
        }
    };

    return function (step, junction) {

        junction('flowStart', true)
            .onNext.branch(submissionViewModel => {
                // for WC7 we start the flow from the beginning
                if (submissionViewModel.value.baseData.productCode === 'WC7WorkersComp') {
                    console.log("73")
                    return branchOnProductCodeFn({wc7: subFlows.wc7Flows}, 'contactDetails')(submissionViewModel);
                }
                return 'effectiveDate';
            });

        step('effectiveDate')
            //Below code has been removed against UCWPRODENG-698
            // .skipOnResumeIf(({value: submission}) => {
            //     if (!isEffectiveDateInTheFuture(submission.baseData.periodStartDate)) {
            //         return false;
            //     }
            //   console.log("84");
            //     // skip if user has visited the first page
            //     return hasUserVisitedFirstStep(submission) || submission.baseData.periodStatus === 'Quoted';

            // })
            .onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSGS.saveSubmission)
            .thenBranch(branchOnProductCodeFn({
                pa: subFlows.paFlows,
                puw: subFlows.puwFlows,
                ho: subFlows.hoFlows,
                cp: subFlows.cpFlows,
                bop: subFlows.bopFlows,
                wc7: subFlows.wc7Flows
            }, 'coverables'))
            .isValid(model => model.aspects.valid && model.aspects.subtreeValid)
            .label(() => TranslateService.instant('quoteandbind.wizard.step.Policy Details'));

    };
}
